var _rect, _path, _rect2, _rect3, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 2.70833,
    fill: "#FCFCFC",
    fillOpacity: 0.1,
    stroke: "#5A6163"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 30.9595L26 32.0333C26.6571 32.0335 27.3078 32.1621 27.9148 32.4118C28.5218 32.6616 29.0732 33.0275 29.5375 33.4888C30.0018 33.9501 30.37 34.4976 30.6208 35.1C30.8717 35.7025 31.0005 36.3481 30.9997 37L32.0003 37C32.0006 35.6847 32.5275 34.4234 33.4651 33.4934C34.4026 32.5634 35.6741 32.0408 37 32.0405L37 30.9667C36.3429 30.9665 35.6922 30.8379 35.0852 30.5882C34.4782 30.3384 33.9268 29.9725 33.4625 29.5112C32.9982 29.0499 32.63 28.5024 32.3792 27.8999C32.1283 27.2975 31.9995 26.6519 32.0003 26L30.9997 26C30.9994 27.3153 30.4725 28.5766 29.5349 29.5066C28.5974 30.4366 27.3259 30.9592 26 30.9595Z",
    fill: "#5A6163"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 30,
    width: 11,
    height: 2,
    rx: 0.320833,
    fill: "#5A6163"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 35,
    width: 11,
    height: 2,
    rx: 0.320833,
    fill: "#5A6163"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 1H28V18L21.5 14L15 18V1Z",
    fill: "#FCFCFC",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 6H42V8H29V6Z",
    fill: "#5A6163"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6H14V8H0V6Z",
    fill: "#5A6163"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductLogo);
export default __webpack_public_path__ + "static/media/product-logo.84e42afa2f7645d51594aba5fdecd75e.svg";
export { ForwardRef as ReactComponent };